export default __webpack_public_path__ + "static/media/Search.dabdd2fd.svg";